<template>
  <div class="notification-panel-container" ref="offcanvasRef">
    <div>
      <div class="close-mobile">
        <svg
          class="closer"
          @click="emit('close-modal')"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="4"
          viewBox="0 0 24 4"
          fill="none"
        >
          <path
            d="M2 2H22"
            stroke="#CDCDCD"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="panel-header">
        <img :src="notificaciones" />
        <ThemedIcon name="LuqueNotificacionesMuni" class="tinker-icon" />
        <h2 class="panel-title h1-heroMuni" id="offcanvasRightLabel">
          Notificaciones
        </h2>
        <ThemedIcon
          name="close"
          @click="emit('close-modal')"
          class="close-icon"
        />
      </div>
    </div>

    <div class="panel-body" v-if="!loading">
      <div class="notificacionHeader">
        <div v-if="mostrarBotonPush" class="activar-push">
          <button class="btn-push" @click="activarPush">
            Activar notificaciones 🔔
          </button>
        </div>

        <!-- <div
          v-if="yourLocalNotificaciones.length > 0 && hayNoLeidas"
          class="actions-header"
        >
          <i
            @click="!loading && marcarTodasComoLeidas()"
            class="bi bi-envelope-open mark-all-btn"
            title="Marcar todas como leidas"
          ></i>
        </div> -->
      </div>

      <div
        v-for="item in yourLocalNotificaciones"
        :key="item.id"
        class="notificacion"
        :class="{ leida: item.read }"
        @click="marcarUnaComoLeidaYVer(item)"
      >
        <div class="noti-header">
          <h3 class="h2-heroMuni">{{ item.subject }}</h3>
          <span class="h3-defaultMuni">{{ formatFecha(item.created_at) }}</span>
        </div>

        <p class="h3-defaultMuni">{{ item.read ? "Leída" : "No leída" }}</p>
      </div>

      <div
        v-if="yourLocalNotificaciones.length === 0"
        class="sin-notificaciones"
      >
        No hay notificaciones por el momento.
      </div>
    </div>
    <div class="loading" v-else>
      <LoadingComponent></LoadingComponent>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted } from "vue";
import close from "@/assets/images/closeDark.svg";
import closeLight from "@/assets/images/closeLight.svg";
import { getNotificaciones } from "@/services/notifications/notificacionService"; // Mantengo esta si aún la usas para el listado inicial
import CommunicationsService from "@/services/office/communicationsService";
import LoadingComponent from "../Modals/Carga/LoadingComponent.vue";
import { navegarDesdeNotificacion } from "@/services/helpers/notificationNavigation";
import { solicitarPermisoNotificaciones } from "@/services/notifications/permissionService";
import { tienePushActivo } from "@/services/notifications/pushStateService";
import { SocketOffice } from "@/services/sockets/officeSocket";
import { getThemeIcon } from "@/services/helpers/themeHelper";
import ThemedIcon from "@/components/Utils/ThemedIcon.vue";

const props = defineProps({
  openFromNoti: {
    type: Function,
    default: () => {},
  },
  closeModal: {
    type: Function,
    default: () => {},
  },
});

const emit = defineEmits(["close-modal"]);

const yourLocalNotificaciones = ref([]);
const cantidadNoLeidas = ref(0);
const loading = ref(false);
const mostrarBotonPush = ref(false);
const closeIcon = ref(getThemeIcon(close, closeLight));

// Computed para saber si mostramos el botón de "Marcar todas"
// const hayNoLeidas = computed(() => {
//   return yourLocalNotificaciones.value.some((n) => !n.read);
// });

function formatFecha(fechaISO) {
  const fecha = new Date(fechaISO);
  return fecha.toLocaleDateString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
const handleVisibility = () => {
  if (document.visibilityState === "visible") {
    actualizarEstadoPush();
  }
};

onMounted(async () => {
  // console.log("Montando panel notificaciones");

  await cargarNotificaciones();

  await actualizarEstadoPush();

  SocketOffice?.off("communications:update");

  SocketOffice?.on("communications:update", () => {
    console.log("Evento communications:update recibido");
    cargarNotificaciones();
  });

  SocketOffice?.on("connect", () => {
    actualizarEstadoPush();
    cargarNotificaciones();
  });

  document.addEventListener("visibilitychange", handleVisibility);

  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener("message", handleSWMessage);
  }
});

const actualizarIcono = () => {
  closeIcon.value = getThemeIcon(close, closeLight);
};

onMounted(() => {
  window.addEventListener("theme-change", actualizarIcono);
});

onUnmounted(() => {
  window.removeEventListener("theme-change", actualizarIcono);
});

const handleSWMessage = (event) => {
  if (event.data?.type === "NEW_NOTIFICATION") {
    // console.log("Nueva notificación recibida");
    cargarNotificaciones();
  }
};

const cargarNotificaciones = async () => {
  loading.value = true;

  try {
    const res = await getNotificaciones();

    yourLocalNotificaciones.value = res?.notificaciones || [];

    actualizarContador();
  } catch (err) {
    console.error("Error cargando notificaciones:", err);
  } finally {
    loading.value = false;
  }
};

const actualizarEstadoPush = async () => {
  if (!("Notification" in window)) return;

  if (Notification.permission === "granted") {
    const activo = await tienePushActivo();
    mostrarBotonPush.value = !activo;
  } else if (Notification.permission === "default") {
    mostrarBotonPush.value = true;
  } else if (Notification.permission === "denied") {
    mostrarBotonPush.value = false;
  }
};

const activarPush = async () => {
  const ok = await solicitarPermisoNotificaciones();
  if (!ok) return;

  await actualizarEstadoPush();
  await cargarNotificaciones();
};

const actualizarContador = () => {
  cantidadNoLeidas.value = yourLocalNotificaciones.value.filter(
    (n) => !n.read,
  ).length;
};

// const marcarTodasComoLeidas = async () => {
//   const unreadItems = yourLocalNotificaciones.value.filter((n) => !n.read);
//   if (unreadItems.length === 0) return;

//   loading.value = true;

//   const ids = unreadItems.map((n) => n.id);

//   const response = await CommunicationsService.markAsRead(ids);

//   if (response.success) {
//     yourLocalNotificaciones.value.forEach((n) => (n.read = true));
//     actualizarContador();
//   } else {
//     console.error("Error al marcar todas:", response.message);
//   }

//   loading.value = false;
// };

const marcarUnaComoLeidaYVer = async (item) => {
  if (!item.read) {
    const response = await CommunicationsService.markAsRead([item.id]);

    if (response.success) {
      item.read = true;
      actualizarContador();
    }
  }

  navegarDesdeNotificacion(item, props.openFromNoti);

  emit("close-modal");
};

onUnmounted(() => {
  SocketOffice?.off("communications:update");
  SocketOffice?.off("connect");

  document.removeEventListener("visibilitychange", handleVisibility);
  if (navigator.serviceWorker) {
    navigator.serviceWorker.removeEventListener("message", handleSWMessage);
  }
});
</script>

<style scoped>
/* -------------------------------------------------------------------------- */
/* AJUSTES PARA PANEL LATERAL (MODAL MANAGER) */
/* -------------------------------------------------------------------------- */
.notification-panel-container {
  height: 100vh;
  width: 28.038vw;
  background-color: var(--bg-popup);
  border-radius: 1rem 0 0 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  padding: 5.008vh 2.196vw;
  display: flex;
  flex-direction: column;
  gap: 3.339vh;
  box-sizing: border-box;
  transform: none !important;
}

.panel-header {
  display: flex;
  align-items: center;
  gap: 0.586vw;
  height: 6.678vh;
  padding: 0;
  flex-shrink: 0;
}

.close-mobile {
  display: none;
  visibility: collapse;
}

.closer {
  width: 6.67vw;
}

.tinker-icon {
  width: 2.928vw;
  height: 6.678vh;
}

.panel-title {
  flex-grow: 1;
}

.close-icon {
  cursor: pointer;
  flex-shrink: 0;
}

.panel-body {
  padding: 0;
  overflow-y: auto;
  flex-grow: 1;
}

/* -------------------------------------------------------------------------- */
/* ESTILOS DE LA LISTA DE NOTIFICACIONES Y ACCIONES */
/* -------------------------------------------------------------------------- */

/* Estilos para el botón de Marcar Todas */
.actions-header {
  display: flex;
  justify-content: flex-end;
  /* Alineado a la derecha */
  padding-bottom: 15px;
}

.mark-all-btn {
  cursor: pointer;
  color: var(--text-primary);
  transition:
    color 0.2s ease,
    transform 0.2s ease;
}

.mark-all-btn:hover {
  opacity: 0.7;
  color: var(--color-success);
}

.mark-all-btn.loading {
  cursor: wait;
  opacity: 0.5;
  text-decoration: none;
}

.loading {
  display: flex;
}

.notificacion {
  margin-bottom: 10px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.2s ease;
  border-bottom: 0.25px solid var(--text-primary);
  padding-bottom: 8px;
  gap: 5px;
  display: flex;
  flex-direction: column;
}

/* Hover */
.notificacion:hover {
  background-color: rgba(0, 195, 168, 0.2);
  box-shadow: inset 0px 0 0 var(--color-success);
}

/* Leídas: hover más suave */
.notificacion.leida:hover {
  background-color: rgba(0, 195, 168, 0.15);
  box-shadow: inset 0px 0 0 var(--color-success);
}

.notificacion.leida {
  opacity: 0.6;
}

.noti-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
}

.sin-notificaciones {
  text-align: center;
  color: #888;
  margin-top: 5.008vh;
}

.activar-push {
  margin-bottom: 15px;
}

.btn-push {
  background: var(--color-success);
  border: none;
  color: var(--bg-popup);
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
}

/* -------------------------------------------------------------------------- */
/* MEDIA QUERIES Y ANIMACIONES (Sin cambios estructurales) */
/* -------------------------------------------------------------------------- */

@media (max-width: 768px) {
  .notification-panel-container {
    height: 80vh;
    width: 100vw;
    gap: 3.18vh;
    padding: 0 5.56vw 2.55vh 5.56vw;
  }

  .close-mobile {
    /* position: absolute; */
    top: 0;
    left: 0;
    width: 100%;
    z-index: 20;
    height: 30px;
    display: flex;
    justify-content: center;
    visibility: visible;
  }

  .closer {
    width: 38px;
    height: 30px !important;
  }


  .close-icon {
    visibility: collapse;
  }

  .tinker-icon {
    width: 8.33vw;
    margin-right: 2.22vw;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%) translateX(-50%);
      opacity: 0;
    }

    to {
      transform: translateY(0) translateX(-50%);
      opacity: 1;
    }
  }

  @keyframes slideDown {
    from {
      transform: translateY(0) translateX(-50%);
      opacity: 1;
    }

    to {
      transform: translateY(100%) translateX(-50%);
      opacity: 0;
    }
  }

  :global(.modal-container:has(.notification-panel-container).opening) {
    animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    opacity: 0;
  }

  :global(.modal-container:has(.notification-panel-container).closing) {
    animation: slideDown 0.3s cubic-bezier(0.7, 0, 0.84, 0) forwards;
    pointer-events: none !important;
  }

  .notificacionHeader {
    display: flex;
    align-items: flex-end;
    gap: 12px;
  }

  .actions-header {
    margin-left: auto;
    padding-bottom: 15px;
  }

  .activar-push {
    margin-bottom: 15px;
  }

  .btn-push {
    background: var(--color-success);
    border: none;
    color: var(--bg-popup);
    padding: 10px 14px;
    border-radius: 8px;
    cursor: pointer;
  }
}

@media (min-width: 769px) {
  @keyframes slidePanelFromRight {
    from {
      transform: translateX(100%) translateY(-50%);
      opacity: 0;
    }

    to {
      transform: translateX(0) translateY(-50%);
      opacity: 1;
    }
  }

  @keyframes slidePanelToRigth {
    from {
      transform: translateX(0) translateY(-50%);
      opacity: 1;
    }

    to {
      transform: translateX(100%) translateY(-50%);
      opacity: 0;
    }
  }

  :global(.modal-container:has(.notification-panel-container).opening) {
    animation: slidePanelFromRight 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    opacity: 0;
  }

  :global(.modal-container:has(.notification-panel-container).closing) {
    animation: slidePanelToRigth 0.3s cubic-bezier(0.7, 0, 0.84, 0) forwards;
    pointer-events: none !important;
    opacity: 1;
  }
}
</style>
